import { RefObject } from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface HiddenColumnsIndicatorProps {
  onCustomize: () => void;
  buttonRef?: RefObject<HTMLButtonElement>;
}

export const HiddenColumnsIndicator = ({ onCustomize, buttonRef }: HiddenColumnsIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-1">
      <span className="text-sm leading-6 text-muted-foreground">{t('common.columns_hidden')}</span>
      <Button
        variant="link"
        onClick={onCustomize}
        className="min-w-0 p-0 leading-6 text-primary"
        ref={buttonRef}
      >
        {t('common.customize')}
      </Button>
    </div>
  );
};
